import { useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { restPath, prefix } from "./../App";

const YearlyPaymentButton = ({ setUserInfo, userInfo, setDone, setIsLoading }) => {
  const { id, expiry, email, status } = userInfo;

  // 名前（日・英）
  const name = userInfo.middleName
    ? `${userInfo.familyName} ${userInfo.middleName} ${userInfo.firstName}`
    : `${userInfo.familyName} ${userInfo.firstName}`;

  const nameEn = userInfo.middleNameEn
    ? `${userInfo.firstNameEn} ${userInfo.middleNameEn} ${userInfo.familyNameEn}`
    : `${userInfo.firstNameEn} ${userInfo.familyNameEn}`;

  // 新しい有効期限
  const newExpiry = useMemo(() => {
    const base = dayjs(expiry).isBefore(dayjs(), "day") ? dayjs() : dayjs(expiry);
    return base.add(1, "year").format("YYYY/MM/DD");
  }, [expiry]);

  useEffect(() => {
    if (!userInfo || !userInfo.id) return;
    const container = document.getElementById("paypal-annual-button");
    if (!window.paypal || !container || container.hasChildNodes()) return;

    window.paypal
      .Buttons({
        createSubscription: (data, actions) =>
          actions.subscription.create({
            // plan_id: "P-0YH751421J151070SNFB6DGI" // ← プランID
            plan_id: "P-92225308N9736384ENE76UEI" // ← プランID
          }),
        // ボタン押下直後に呼ばれる
        onApprove: (data) => {
          console.log("✅ Subscription approved:", data);

          setIsLoading(true);

          const payload = {
            userId: id,
            name,
            nameEn,
            email,
            unit: `year`,
            orderId: data.subscriptionID,
            expiry: newExpiry,
            quantity: 1,
            amount: 4800
          };

          console.log("📦 Payload:", payload);
          console.log("📡 REST API path:", restPath);

          fetch(`${restPath}/wp-json/${prefix}yearlyplan/v1/subscribe`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          })
            .then((res) => {
              if (!res.ok) throw new Error(`HTTP error ${res.status}`);
              return res.json();
            })
            .then((data) => {
              console.log("✅ 登録完了:", data);

              console.log(data.orderId)

              const updatedUserInfo = {
                ...userInfo,
                orderId: data.orderId,
                expiry: newExpiry,
                unit: 'year',
                quantity: 1,
                amount: 4800,
                membership: "individual",
                paymentMethod: "paypal_subscription",
              };

              console.log(updatedUserInfo)

              setUserInfo(updatedUserInfo);
              sessionStorage.setItem("jacUserCore", JSON.stringify(updatedUserInfo));
              setDone("success");
            })
            .catch((err) => {
              console.error("❌ 登録失敗:", err);
              setDone("failed");
            })
            .finally(() => {
              setIsLoading(false);
            });
        },
        onError: (err) => {
          console.error("❌ PayPal subscription error:", err);
          setDone("failed");
          setIsLoading(false);
        },
        onCancel: (data) => {
          console.log("❌ ユーザーがキャンセルしました:", data);
          setDone(undefined);   // 状態をキャンセルに更新
          setIsLoading(false);    // ローディング解除
        }
      })
      .render("#paypal-annual-button");
  }, [id, email, status, name, nameEn, newExpiry, setUserInfo, setDone, setIsLoading]);

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        小計：₱4,800
      </Typography>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        更新後の有効期限：{newExpiry}
      </Typography>
      <Box id="paypal-annual-button" sx={{ mt: 2 }} />
    </Box>
  );
};

export default YearlyPaymentButton;
